/**
 * @file Account roles constant/enum.
 */

const ACCOUNT_PRO_ROLES = {
  CAMP_ADMIN: 'camp_admin',
  EVENT_ORGANIZER: 'event_organizer',
  PHOTOGRAPHER: 'photographer',
  RESORT_ADMIN: 'resort_admin',
  SCHOOL_ADMIN: 'school_admin',
  GREEK_ADMIN: 'greek_admin',
  SPORTS_ADMIN: 'sports_admin',
  CHURCH_ADMIN: 'church_admin',
};

const ACCOUNT_ROLES = {
  ADMINISTRATOR: 'administrator',
  CONSUMER: 'consumer',
  USER_ADMIN: 'user_admin',
  COMMANDER: 'commander',
  SHUTTERBUG: 'shutterbug',
  ...ACCOUNT_PRO_ROLES,
};

/**
 * Roles that have accesss to the PRO dashboard.
 *
 * @type {{RESORT_ADMIN, SCHOOL_ADMIN, CAMP_ADMIN, EVENT_ORGANIZER, PHOTOGRAPHER, SHUTTERBUG}}
 */
const ACCOUNT_DASHBOARD_ROLES = {
  ...ACCOUNT_PRO_ROLES,
  SHUTTERBUG: ACCOUNT_ROLES.SHUTTERBUG,
};

export { ACCOUNT_PRO_ROLES, ACCOUNT_DASHBOARD_ROLES };
export default ACCOUNT_ROLES;
